import {FC, useEffect, useState} from 'react'
import Content from "../main/Content";
import ServiceButtons from "./ServiceButtons";
import RepairDescription from "./RepairDescription";
import Offers from "../Campaign";
import Mileage from "../Car/Mileage";
import ScrollTo from "../common/ScrollTop/ScrollTo";
import {getServices} from "../../wordpress/operations/get-services";
import NavNextPrev from "../common/NavNextPrev/NavNextPrev";

interface Props {
    booking: Booking
    pageContent:ContentPage,
    setBooking: Function,
    content: Content
}

const Service: FC<Props> = ({ pageContent, booking, setBooking, content }) => {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    const [services, setServices] = useState<any | null>(null);

    if (!services) {
        getServices(booking).then((val) => {
            setServices(val)
        })
    }

    if(!services || services.lenght === 0) {
        return <></>
    }

    const authCarClass = booking.car.authorized ? 'authorized_car_brand' : 'unauthorized_car_brand'

    return (
        <div className={`input-outer reg-container ${authCarClass}`}>
            <div className="row mobile-reverse">
                <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 col-xxs-12">
                    <Offers booking={booking} setBooking={setBooking}/>
                </div>
                <div className="main-bg col-lg-8 col-md-8 col-sm-12 col-xs-12 col-xxs-12" id={'service-buttons'}>
                    <Content booking={booking} content={pageContent}/>
                    <ServiceButtons buttons={services} booking={booking} setBooking={setBooking}/>

                    <div className={'wco-booking-car-reparation'}>
                        <Mileage setBooking={setBooking} booking={booking}/>
                        {booking.service.name === 'Reparation' && (
                            <RepairDescription setBooking={setBooking} booking={booking}/>)}
                    </div>

                    <div id={'service-buttons'}>
                        <ScrollTo title={'Lägg till tjänst'}/>
                        <div className={"pt-5"}>
                            <NavNextPrev booking={booking} setBooking={setBooking} content={content}/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default Service
